import React from "react";

const NotFound = () => {

  return <div style={{ marginTop: "10%", textAlign: "center" }}>
    <h1>404</h1>
    <h1 >Not Found</h1>
  </div>
};

export default NotFound;
